import { ManageAreaRepositoryInterface } from "@/data/persistences/repositories/contracts/ManageAreaRepositoryInterface";
import ApiService from "../../services/ApiService";
import { ManageAreaMapper } from "@/data/persistences/mappers/ManageAreaMapper";
import { ManageAreaEndpoint } from "../../endpoints/ManageAreaEndpoint";
import {
  ManageAreaData,
  ResponseSummaryGeoAddressData,
  ResponseTransferAreaData,
  AvailableCourierList,
  GeoAddressArea,
  DetailPartnerAreaDedicated,
  UpdatePartnerAreaDedicated
} from "@/domain/entities/ManageArea";
import {
  ListManageAreaApiRequest,
  ListAvailableCourierApiRequest,
  ListGeoAddressApiRequest,
  UpdatePartnerAreaRequest,
  TransferAreaApiRequest,
  AvailableGeoAddressApiRequest,
  CreateAreaApiRequest,
} from "@/data/payload/api/ManageAreaApiRequest";
import { ResponsePayloadV2, ResponsePayload } from "@/domain/entities/ResponsePayload";
import { UpdatePartnerAreaRequestInterface } from '@/data/payload/contracts/ManageAreaRequest';

export class ManageAreaApiRepository implements ManageAreaRepositoryInterface {
  private service: ApiService;
  private mapper: ManageAreaMapper;
  private endpoints: ManageAreaEndpoint;

  constructor(
    service: ApiService,
    mapper: ManageAreaMapper,
    endpoints: ManageAreaEndpoint
  ) {
    this.service = service;
    this.mapper = mapper;
    this.endpoints = endpoints;
  }

  public async getList(
    params: ListManageAreaApiRequest
  ): Promise<ManageAreaData> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getList(params),
      {}
    );
    return this.mapper.convertListManageAreaFromApi(resp);
  }

  public async getSummaryGeoAddress(): Promise<ResponseSummaryGeoAddressData> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getSummaryGeoAddress(),
      {}
    );
    return this.mapper.convertSummaryGeoAddressFromApi(resp);
  }
  
  public async getGeoAddress(
    params: ListGeoAddressApiRequest
  ): Promise<ResponsePayloadV2> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getGeoAddress(params),
      {}
    );
    return this.mapper.convertGeoAddressFromApi(resp);
  }

  public async getAvailableCourier(
    params: ListAvailableCourierApiRequest
  ): Promise<AvailableCourierList> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getAvailableCourier(params),
      {}
    );
    return this.mapper.convertAvailableCourierFromApi(resp);
  }

  public async getTransferArea(uid: string): Promise<ResponseTransferAreaData> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getTransferArea(uid),
      {}
    );
    return this.mapper.convertTransferAreaFromApi(resp);
  }

  public async postTransferArea(payload: TransferAreaApiRequest): Promise<boolean> {
    await this.service.invoke(
      "post",
      this.endpoints.postTransferArea(),
      undefined,
      payload
    );
    return true;
  }
  
  public async delete(uid: string): Promise<any> {
    return await this.service.invoke("delete", this.endpoints.delete(uid), {});
  }

  public async getAvailableGeoAddress(params: AvailableGeoAddressApiRequest): Promise<GeoAddressArea[]> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getAvailableGeoAddress(params)
    )

    return this.mapper.convertAvailableGeoAddressFromApi(resp);
  }

  public async createArea(payload: CreateAreaApiRequest): Promise<boolean> {
    await this.service.invoke(
      "post",
      this.endpoints.createArea(),
      undefined,
      payload
    )

    return true;
  }

  public async getDetail(uid: string): Promise<DetailPartnerAreaDedicated> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getDetail(uid),
      {}
    );
    return this.mapper.convertDetailPartnerAreaFromApi(resp);
  }

  public async update(
    uid: string,
    payload: UpdatePartnerAreaRequestInterface
  ): Promise<UpdatePartnerAreaDedicated> {
    const resp = await this.service.invoke(
      "put",
      this.endpoints.update(uid),
      undefined,
      payload as UpdatePartnerAreaRequest
    );
    return this.mapper.convertUpdatePartnerAreaFromApi(resp);
  }
}
